import POST from "./simplePost";

export const { searchItem, getLineChart, getBarChart, newItem, updateItem } =
  POST;

export { getConst } from "./const";
